define(()=> {
    /**
     * Default behavior for displaying status information about an action
     *  Progress: while the action is in progress then a progress dialog will be shown with a progress message if provided
     *  Success: if there is a success message provided then a success message will be displayed, otherwise no dialog is displayed
     *  Error: if the action results in an error then an error dialog will be show with the error message if provided
     */
    return function (ModalComponent) {
        const defaultActionMsgs = {
            error: {
                title: 'platform.flow.angularhelpers.ActionStatusMessages.Unable to perform operation',
                message: 'platform.flow.angularhelpers.ActionStatusMessages.An error occurred, please contact your agent'
            },
            progress: {
                message: 'platform.flow.angularhelpers.ActionStatusMessages.Processing operation...'
            }
        };

        return function (actionPromise, actionMsgs = defaultActionMsgs) {
            const progressClosedPromise = ModalComponent.showProgressDialog(actionMsgs.progress.message, actionPromise).result;

            return progressClosedPromise.then(resp => {
                if (actionMsgs.success) {
                    const successMsg = () => actionMsgs.success.message;
                    //when the dialog is closed return the response from the action
                    return ModalComponent.showSuccess(successMsg, successMsg).result.then(() => resp);
                }
                return resp;
            }).catch(e => {
                // Default error messages for the state
                if(actionMsgs.error){
                    var errorTitle = actionMsgs.error.title;
                    var errorMessage = actionMsgs.error.message;
                }
                
                // Server response
                // Overriding default error messages if systemdown has valid value
                if(angular.isDefined(e.extraArgs.error) && e.extraArgs.error.length > 0){
                    var baseError = e.extraArgs.error[0].baseError;
                    if (baseError.statusText == "Internal Server Error" && actionMsgs.systemdown){
                        errorTitle = actionMsgs.systemdown.title;
                        errorMessage = actionMsgs.systemdown.message;
                    }
                }
                //US-10685, Added to display PC validation error
                if(angular.isDefined(e.extraArgs.error) && e.extraArgs.error.length > 0){
                    var baseError = e.extraArgs.error[0].baseError;
                    if (baseError && baseError.statusText == "Server Error" && baseError.data && baseError.data.error && baseError.data.error.message){
                        errorTitle = 'platform.flow.angularhelpers.ActionStatusMessages.Unable to perform operation';
                       // errorMessage = baseError.data.error.message;
                        errorMessage ='platform.flow.angularhelpers.ActionStatusMessages.validationError';
                    }
                }
                //US-10685, Ended to display PC validation error

                //when the dialog is closed return throw an error to trigger the next error handler in the chain
                if(errorTitle && errorMessage) {
                    if(errorTitle === "quoteandbind.controllers.ZipCodeCtrl.Error"){
                        return ModalComponent.showError(errorTitle, errorMessage).result.then(() => {
                            throw e;
                        });
                    }
                     throw e;
                }
                //US-10685, Added to display PC validation error
                else{
                    throw e;
                }
                //US-10685, Ended to display PC validation error
            });
        };
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/flow/angularhelpers/ActionStatusMessages.js
 **/